import * as React from 'react';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { AdminItemCardButtons } from 'components';
import { IItemCardProps, IAdminItemCardButtonsProps } from 'models/itemcard';
import * as moment from 'moment';
import { ArticleStatus } from 'models/enums/statuses';
import * as c from 'models/constants';
import { translate } from 'react-i18next';

interface IProps extends IItemCardProps {
	item: IArticleListCard;
	itemSettings?: (itemId: string) => void;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminArticleItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.viewItem = this.viewItem.bind(this);
		this.openItemSettings = this.openItemSettings.bind(this);
	}

	public editItem() {
		if (this.props.editItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.editItem(entityIdObj.id);
		}
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.deleteItem(entityIdObj.type, entityIdObj.id);
		}
	}

	public viewItem(e: any) {
		e.stopPropagation();
		if (this.props.viewItem) {
			this.props.viewItem(JSON.parse(this.props.item.entityId).id);
		}
	}

	public openItemSettings(e: any) {
		e.stopPropagation();
		if (this.props.itemSettings) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.itemSettings(entityIdObj.id);
		}
	}

	public render() {
		const { currentUserId, currentUserIsAdministrator } = this.props;
		const { name, addedBy, status, userId, addedDate, picture } = this.props.item;
		const { t } = this.props;

		const adminItemCardButtonsProps: IAdminItemCardButtonsProps = {
			deleteItem:
				this.props.deleteItem !== undefined &&
				((status !== ArticleStatus.Approved && currentUserId === userId) || currentUserIsAdministrator)
					? this.deleteItem
					: null,
			viewItem: this.viewItem,
			settingsItem: this.openItemSettings,
		};

		return (
			<div className="adminItemCard adminArticleItemCard">
				<div className="innerHolder" onClick={this.editItem}>
					<div className="image">{picture && <img src={picture} alt={`${name}'s picture`} />}</div>
					<div className="title">{name}</div>
					<div className="published">
						<div className="status">{t('CodeList_ArticleStatus_' + status)}</div>
					</div>
					<div className="author">{addedBy}</div>
					<div className="created-date">
						<span>{moment(addedDate).format('L')}</span>
					</div>
					<div className="control-big">
						<AdminItemCardButtons {...adminItemCardButtonsProps} />
					</div>
				</div>
			</div>
		);
	}
}

export { AdminArticleItemCard };
